const prefix = 'esnap';

export default {
    update: `${prefix}.update`,
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/actions/Esnap.js